import React, { useState,useEffect } from "react";
import { Dialog, Box, Grid, IconButton, Typography, TextField, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { FaFacebook } from "react-icons/fa";
import TwitterIcon from "@mui/icons-material/Twitter";
import GoogleIcon from "@mui/icons-material/Google";
import YouTubeIcon from "@mui/icons-material/YouTube";
import axios from "axios";
import { useNavigate } from "react-router-dom"; // Import useNavigate

const ReferralDialog = ({ open, handleClose }) => {
  const [referralCode, setReferralCode] = useState("");
  const [error, setError] = useState(""); // Error message state
  const [success, setSuccess] = useState(""); // Success message state
  const navigate = useNavigate(); // Initialize useNavigate
 
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate input
    if (!referralCode) {
      setError("Please enter a referral code.");
      return;
    }

    setError(""); // Clear previous errors
    setSuccess(""); // Clear previous success message

    const requestData = {
      ComID: "EH25",
      Flag: "CK",
      ReferralID: referralCode,
    };

    try {
      const response = await axios.post("https://testing.esnep.com/magnessa/api/vendor/referral", requestData);
      
      if (response.data.StatusCode === 200 && response.data.AcntLst === null) {
        // console.log("Navigating to /registers");
        setError(""); // Clear error if successful
        setSuccess("Referral code verified successfully! Redirecting...");
        sessionStorage.setItem("referralCode", referralCode); // Save to session storage
        sessionStorage.setItem("referralVerified", "true"); // Store a flag
        setTimeout(() => {
            handleClose(); // Close dialog
            navigate("/registers");
          }, 3000);
      } else {
        setError(response.data.Message || "Invalid Referral Code."); // Show error below input field
      }
    } catch (error) {
      setError("Error verifying referral code. Please try again.");
    }
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <Box
        sx={{
          maxWidth: 800,
          margin: "auto",
          backgroundColor: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "0px",
        }}
      >
        <Grid container spacing={2}>
          {/* Left side (Image) */}
          <Grid
            item
            xs={12}
            sm={6}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "0 !important",
              height: "350px",
            }}
          >
            <img
              src="https://images.unsplash.com/photo-1695527081782-c4ad3005417e?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              alt="Login"
              style={{
                width: "100%",
                height: "100%",
                maxHeight: "100%",
                objectFit: "cover",
              }}
            />
          </Grid>

          {/* Right side (Form) */}
          <Grid item xs={12} sm={6} sx={{ padding: "20px", position: "relative" }}>
            <IconButton
              onClick={handleClose}
              sx={{
                position: "absolute",
                top: "16px",
                right: "0px",
                color: "#fff",
                fontSize: "24px",
                borderRadius: "0px",
                background: "#d32f2f",
                "&:hover": {
                  backgroundColor: "#f5f5f5",
                  color: "#000",
                },
              }}
            >
              <CloseIcon />
            </IconButton>

            <Typography
              variant="h4"
              gutterBottom
              sx={{
                color: "#0f1111",
                fontWeight: "bold",
                marginBottom: "20px",
                fontSize: "1.4rem",
                marginTop: "50px",
              }}
            >
              Referral Code to Register
            </Typography>
            

            <form onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                {/* Referral Code */}
                <Grid item xs={12}>
                  <TextField
                    label="Referral Code"
                    name="refcode"
                    fullWidth
                    required
                    variant="outlined"
                    value={referralCode}
                    onChange={(e) => setReferralCode(e.target.value)}
                    error={!!error} // Convert error message to boolean for MUI's error prop
                    helperText={error} // Display error message below input field
                    InputLabelProps={{ style: { fontSize: 10 } }}
                  />
                </Grid>
                {success && (
  <Typography
    variant="body2"
    sx={{
      color: "green",
      marginTop: "10px",
      marginLeft:"15px",
      fontSize: "12px",
      textAlign: "center",
    }}
  >
    {success}
  </Typography>
)}

                {/* Submit Button */}
                <Grid item xs={12}>
                  <Button
                    type="submit"
                    variant="contained"
                    fullWidth
                    sx={{
                      backgroundColor: "#2FA8EF",
                      color: "#fff",
                      fontWeight: "bold",
                      padding: "5px",
                      marginTop: "10px",
                      fontSize: "12px",
                      "&:hover": {
                        backgroundColor: "#1E7CB7",
                      },
                    }}
                  >
                    Submit
                  </Button>
                </Grid>

                {/* Social Media Icons Below Submit Button */}
                <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "15px",
                    marginTop: "15px",
                  }}
                >
                  {[{ icon: <FaFacebook />, link: "#" }, { icon: <TwitterIcon />, link: "#" }, { icon: <GoogleIcon />, link: "#" }, { icon: <YouTubeIcon />, link: "#" }].map(
                    (item, index) => (
                      <IconButton
                        key={index}
                        href={item.link}
                        sx={{
                          width: "35px",
                          height: "35px",
                          backgroundColor: "#f0f0f0",
                          borderRadius: "50%",
                          color: "#555",
                          "&:hover": { backgroundColor: "#ddd" },
                        }}
                      >
                        {item.icon}
                      </IconButton>
                    )
                  )}
                </Grid>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </Box>
    </Dialog>
  );
};

export default ReferralDialog;
